import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import { API } from "@/lib/api";

export const shortAddr = (a) => (a ? `${a.slice(0, 4)}…${a.slice(-4)}` : "");

export function usePhantom() {
  const [phantom, setPhantom] = useState({ address: null, balance: null, connecting: false });

  const fetchSolBalance = useCallback(async (addr) => {
    try {
      const r = await fetch(`${API}/solana/balance/${addr}`);
      if (!r.ok) throw new Error("rpc");
      const d = await r.json();
      setPhantom((p) => ({ ...p, balance: d.sol }));
    } catch {
      setPhantom((p) => ({ ...p, balance: null }));
    }
  }, []);

  const connectPhantom = useCallback(async () => {
    if (!window.solana?.isPhantom) {
      toast.error("Phantom wallet not detected", {
        description: "Install Phantom from phantom.app",
        action: { label: "Install", onClick: () => window.open("https://phantom.app/", "_blank") },
      });
      return;
    }
    setPhantom((p) => ({ ...p, connecting: true }));
    try {
      const { publicKey } = await window.solana.connect();
      const addr = publicKey.toString();
      setPhantom({ address: addr, balance: null, connecting: false });
      localStorage.setItem("emg_phantom", "1");
      toast.success("Phantom connected", { description: shortAddr(addr) });
      fetchSolBalance(addr);
    } catch {
      setPhantom((p) => ({ ...p, connecting: false }));
      toast.error("Connection cancelled");
    }
  }, [fetchSolBalance]);

  const disconnectPhantom = useCallback(async () => {
    try {
      await window.solana?.disconnect();
    } catch (e) {
      console.warn("phantom disconnect failed", e?.message);
    }
    localStorage.removeItem("emg_phantom");
    setPhantom({ address: null, balance: null, connecting: false });
  }, []);

  // Auto-reconnect on page load
  useEffect(() => {
    if (window.solana?.isPhantom && localStorage.getItem("emg_phantom") === "1") {
      window.solana
        .connect({ onlyIfTrusted: true })
        .then(({ publicKey }) => {
          const addr = publicKey.toString();
          setPhantom({ address: addr, balance: null, connecting: false });
          fetchSolBalance(addr);
        })
        .catch(() => {});
    }
  }, [fetchSolBalance]);

  return { phantom, connectPhantom, disconnectPhantom };
}
